export default __webpack_public_path__ + "static/media/information--turn-right-ahead--g1.35a96c2a.png";